import * as React from 'react';

import { Header } from './header';
import { HeaderNavigationSelect } from './header-navigation-select';

export const recruitingPageRoutes: Array<[string, string]> = [
    ['Recruiting Stats', '/stats/recruiting'],
    ['Recruiter Pipeline', '/stats/recruiter-pipeline']
];

export const RecruitingPageHeader: React.FC = () => {
    const title = <HeaderNavigationSelect routes={recruitingPageRoutes} />;
    return <Header title={title} />;
};
